import { useEffect, useState } from "react";

/**
 * Reactive boolean for whether the document is currently visible. Useful for
 * pausing animations / polling when the tab is backgrounded.
 *
 *   const visible = useDocumentVisibility();
 *   useInterval(poll, visible ? 5000 : null);
 *
 * SSR-safe: returns `true` on the server.
 */
export function useDocumentVisibility(): boolean {
  const [visible, setVisible] = useState<boolean>(() =>
    typeof document === "undefined" ? true : !document.hidden,
  );

  useEffect(() => {
    const onChange = () => setVisible(!document.hidden);
    document.addEventListener("visibilitychange", onChange);
    return () => document.removeEventListener("visibilitychange", onChange);
  }, []);

  return visible;
}
